<template>
    <div class="main-bayes-page">

        <div class = 'total_bay_item'>
            <div class="quick_panel">
                <button title="后验概率全计算" @click="calc_a('all')">全部概率计算</button>
                <button title="自动把A事件的概率数值归一化" @click="PA_normalize">事件A归一化</button>
                <button title="撤销事件A数值归一化,如果已经修改不可撤销" @click="cancel_PA_normalize" v-show="last_PA.length>0">撤销归一化</button>
                <button title="自动补齐对立事件或者新建事件" @click="auto_add_item">智能添加事件</button>
                <button title="事件重复进行" @click="repeat_event">事件重复</button>
                <button title="自定义事件" @click="custom_event">自定义事件</button>
                <button title="隐藏边栏" @click="$emit('toggle_panel')">隐藏侧边栏</button>
            </div>
            <div class="quick_panel2">
                
                <button title="案例说明" @click="case_introduce"> 案例引入</button>
                <button title="学习视频" @click="case_video"> 视频学习</button>
                <button title="对学习使用过程进行反馈" @click="my_think">我的反思</button>
            </div>
           
            <bay-item-info 
                :event_info="event_info" 
                :sample_list="sample_list"
                @sample_change="sample_change"
            >
            </bay-item-info>

            <!-- <button class="btn_calc_a" @click="calc_a">先验计算</button> -->
            <!-- <button class="btn_calc_b" @click="calc_b">后验计算</button> -->

            <div class="bay-item-card-list">
                <!--为了处理display justify-content 与 overflow内容显示不全的问题-->
                <div class="content-wrapper">
                    <bay-item 
                    v-for="(item,idx) in items"
                    :key = "idx"
                    :bay_item="item"
                    :event_info="event_info"
                    :is_bi="is_bi(items,idx)"
                    :index = "idx"  
                    :editable = "idx==items.length-1" 
                    @add_item="add_item"             
                    @remove_item="remove_item"   
                    @update_data="has_update"    
                    @calc_pa="calc_pa"      
                    @help-msg="help_msg"
                    /> 
                </div>
            </div>
  
            
        <!-- <div class="btn_calc_a" @click="calc_a">
                全概率计算
        </div> -->
        </div>

         <bay-item-footer
         :content="create_calc_eq"
         :value = "PB_result"
         :title = "PB_info"
         @calc_PB="calc_a('no_pb')"
         ></bay-item-footer>
    </div>
</template>

<script>
import BayItem from './BayItem/BayItem.vue';
import BayItemFooter from './BayItem/BayItemFooter.vue';
import BayItemInfo from './BayItem/BayItemInfo.vue';

import {sample_list,name_templete,create_new_item} from '~js/sample_list.js';
import {msgbox} from '~js/smallarAlert.esm.js';
import {class_help_fn,case_introduce_fn,my_think_fn,case_video_fn} from '~js/teacher_help.js';
// import {msgbox} from '~v_url/V-LAB/script/smallarAlert.esm.js';

let bayes_list = JSON.parse(JSON.stringify(sample_list));

export default {
    name:'BayesCaculator',
    created(){
        let arr = [];
        let scope = this;
        document.onkeydown = function(e) {
            if(arr.length > 0) { // a-z按键长按去重
                if(arr.indexOf(e.key.toLowerCase()) >= 0) {
                    return
                }
            }
            arr.push(e.key.toLowerCase())
            this.keydown = arr.join('+');
            if(this.keydown == 'alt+c') {
                this.keydown = '';
                scope.calc_a()
            };
            if(this.keydown == 'alt+b') {
                this.keydown = '';
                scope.calc_b()
            };
        }
        document.onkeyup = function (e) {
            arr.splice(arr.indexOf( e.key.toLowerCase() ),1);
            this.keydown = arr.join('+');
        }
        this.keydown = '';

    },
    mounted() {
        console.log(bayes_list);
        this.sample_list = Object.keys(bayes_list);
        this.s_name = this.sample_list[0];
        this.event_info.sample_name = bayes_list[this.s_name].event_info.sample_name;
        this.event_info.event_A = bayes_list[this.s_name].event_info.event_A;
        this.event_info.event_B = bayes_list[this.s_name].event_info.event_B;
        console.log(sample_list);
        console.log(bayes_list[this.s_name].event_info);
        console.log(this.event_info);
        this.event_info['sample_name'] = this.s_name;
        console.log(this.event_info);
        
        this.items = bayes_list[this.event_info.sample_name].items;
        this.name_templete = name_templete;
    },
    data(){
        return {
            
            last_PA:[],
            PB_result:'-',
            bars:['源','流','和'],
            name_templete:{PB_item:'P(B|A{n})*P(A{n})',},
            sample_list:["a","泥沙入海","c"],
            s_name:"",
            has_calc_PB:false,
            event_info:{
                
                event_A:'水流量',
                event_B:'含沙量',
                sample_name:"泥沙入海",
            },
            items:[
                {
                    name_object:
                    {
                        name:'类型1',
                        value:'长江',
                        index:1
                    },
                    l_object:{
                        a_object:{
                            name:"P(A1)",
                            value:0.5
                        },
                        b_object:{
                            name:"P(B|A1)",
                            value:0.5
                        },

                    },

                    r_object:{
                        a_object:{
                            name:"P(A1|B)",
                            value:'-'
                        },
                        b_object:{
                            name:"P(B|A1)*P(A1)",
                            value:'-'
                        },

                    },
                }
                
            ],
        }
    },
    methods: {
        case_video(){
            console.log('案例视频');
            case_video_fn(this.s_name);
        },
        my_think(){
            console.log('my_think');
            my_think_fn();
        },
        case_introduce(){
            console.log('case introduce of',this.s_name);
            case_introduce_fn(this.s_name);
        },
        help_msg(par){
            console.log('help msg',this.s_name,par);
            class_help_fn(this.s_name,par);
        },
        is_bi(list,idx){//判断是否为二元正反事件，提示会不一样
            console.log('calc bi');
            let last_item_name = list[list.length - 1].name_object.value;
            return list.length===2 && (last_item_name.startsWith('不') || last_item_name.startsWith('无') || last_item_name.startsWith('否') || last_item_name.startsWith('非') || last_item_name.startsWith('其它') || last_item_name.startsWith('其他') || last_item_name.startsWith('没有') || last_item_name.startsWith('no'))
        },
        has_update(attr='all'){//修改了属性值，需要调整计算结果为未知
            console.log('has update')
            this.items.map(v=>{
                if(attr=='all'||attr=='a')v.r_object.a_object.value = '-';
                if(attr=='all'||attr=='b')v.r_object.b_object.value = '-';

            });
            if(attr=='all'||attr=='B')this.PB_result ='--';
            this.has_calc_PB = false;

        },
        custom_event(){
            this.event_info.sample_name = this.sample_list[this.sample_list.length-1];
        },
        repeat_event(){
            let can_repeat = true;
            this.items.map(v=>{
                let a = Number(v.r_object.a_object.value);
                if(isNaN(a))can_repeat = false;
            });
            if(!can_repeat){
                msgbox({type:'pop',title:'提示',msg:'请先完成后验概率计算',show_time:800});
                return ;
            }
            this.items.map(v=>{
                let a = Number(v.r_object.a_object.value);
                if(!isNaN(a))if(a>0)v.l_object.a_object.value = v.r_object.a_object.value;
            });
            this.has_update();
        },
        auto_add_item(){
            console.log('auto add item');
            let index = this.items.length + 1;
            let new_item = create_new_item(index);
            //智能猜测
            if(this.items.length==1){
                new_item.name_object.value = "非"+this.items[0].name_object.value;
                new_item.l_object.a_object.value = 1 - this.items[0].l_object.a_object.value;
            }else{
                new_item.name_object.value = "其它";
                let pa_total = this.calc_pa_total();
                
                if(pa_total<1) new_item.l_object.a_object.value = 1 - pa_total;
            };
            this.items.push(new_item);
            this.focus_last_name();
            this.has_update();

        },
        cancel_PA_normalize(){
            let max_indx = this.items.length;
            if(this.last_PA.length>0)this.last_PA.map((v,idx)=>{
                if(idx<max_indx)this.items[idx].l_object.a_object.value = v;
            });
            this.last_PA = [];
            this.has_update();

        },
        PA_normalize(){
            let scope = this;
            if (this.items.length==1){
                msgbox({type:'pop',title:'提示',msg:'只有一个事件类型,请使用智能添加补齐事件或者手动新增事件参数',show_time:500});
                return
            };
            let PA_total = this.calc_pa_total();
            scope.last_PA = [];
            if(PA_total>0)this.items.map(v=>{
                scope.last_PA.push(v.l_object.a_object.value);
                v.l_object.a_object.value *= 1/PA_total;
            });
            this.has_update();
            
        },
        calc_pa(index){
            console.log('calc right pa:'+index);
            let pb = Number(this.PB_result);
            if(isNaN(pb)){
                msgbox({type:'pop',title:'提示',msg:'请先进行全概率计算',show_time:500});
                return;
            }
            if(index=='all'){
                this.calc_b()
            }else{
                 this.items[index].r_object.a_object.value =  '*' + this.items[index].r_object.a_object.value;
                setTimeout(()=>{
                    this.items[index].r_object.a_object.value = this.items[index].r_object.b_object.value /pb;
                },100);
                
            }
            
        },
        calc_pa_total(){
            let PA_total=0;
            this.items.map(v=>{PA_total += v.l_object.a_object.value*1;});
            return PA_total;
        },
        calc_a(calc='all'){//先验概率计算
            console.log('A calc');
            let PA_total=0;
            let scope = this;
            //求和
            this.items.map(v=>{
                v.r_object.b_object.value = v.l_object.a_object.value * v.l_object.b_object.value;
                PA_total += v.l_object.a_object.value*1;
            });

            //更改b的值
            scope.has_update('b');

            //计算r_object.b_object.value
            let calc_rb = function(){
                scope.items.map(v=>{
                    v.r_object.b_object.value = v.l_object.a_object.value * v.l_object.b_object.value;
                });
            };

            //加入延时是为了显示元素变化过程,
            setTimeout(()=>{
                           if(PA_total>1 || PA_total<1){
                if(this.items.length==1){
                    let new_par_info = `非${this.items[0].name_object.value} 中 ${this.event_info.event_B} 的比值`;
                    msgbox({
                    type:'confirm',
                    title:'提示',
                    msg:`由于你仅添加单个事件,是否自动补齐对向事件或者返回修改参数值<br>
                         参数补充<br>
                         ${new_par_info} P(A2|B):<br>
                         <input id="msg_input" style="width:50px;" onkeyup="this.value=this.value.replace(/[^\\d.]/g,'')">
                            `,
                    yes_txt:'自动补齐',
                    no_txt:'返回修改',
                    lazy_exit:true,
                    callback:()=>{
                        //归一化

                        let new_par = document.querySelector('#msg_input').value;
                        if(new_par){
                            this.auto_add_item();
                            this.items[1].l_object.b_object.value = new_par;
                            calc_rb();
                            scope.calc_PB();
                            if(calc=='all')scope.calc_b();
                        }
     
                    },
                    callback2:()=>{
                        console.log('user cancel');
                    }
                })
                }else{
                     msgbox({
                        type:'confirm',
                        title:'提示',
                        msg:'由于你添加的事件A概率和不为1,可以选择归一化或者返回修改参数值',
                        yes_txt:'概率归一化',
                        no_txt:'返回修改',
                        callback:()=>{
                            //归一化
                            scope.last_PA= [];
                            scope.items.map(v=>{
                                scope.last_PA.push(v.l_object.a_object.value);
                                v.l_object.a_object.value *= 1/PA_total;
                            });
                            calc_rb();
                            scope.calc_PB();
                            if(calc=='all')scope.calc_b();
                        },
                        callback2:()=>{
                            console.log('user cancel');
                        }
                    })
                }
               
            }else{
                 calc_rb();
                 scope.calc_PB();
                 if(calc=='all')scope.calc_b();
            }




            },10)



 

            
        },
        calc_b(){//先验概率计算
            console.log('B calc');
            // msgbox({type:'pop',title:'提示',msg:'B calc',show_time:5000});
            
            this.items.map(v=>{
                v.r_object.a_object.value = v.r_object.b_object.value /this.PB_result;
            })
        },
        calc_PB(){
            console.log('calc PB');
            this.has_calc_PB = true;
            let res = 0;
            this.items.map(v=>{
                res  += v.r_object.b_object.value;
            });
            this.PB_result = res.toString();
            return res;
        },
        add_item(index){
            console.log('add_item after index:' + index);
            if(index===undefined)index = this.items.length-1;
            index = index + 2;

            let new_item = create_new_item(index);

            this.items.push(new_item);
            this.focus_last_name();
            this.has_update();

        },
        remove_item(index){
            console.log('add_item after index:' + index);
            if(index===undefined)index = this.items.lenght - 1;
            if(index==0)return;
            this.items.splice(index,1);
            this.focus_last_name();
            this.has_update();
        },
        sample_change(){//已弃用，通过监控event_info的变化来change
             console.log('event_info changed from recive sample change');
                bayes_list = JSON.parse(JSON.stringify(sample_list));
                this.event_info.event_A =  bayes_list[this.event_info.sample_name].event_info['event_A'];
                this.event_info.event_B = bayes_list[this.event_info.sample_name].event_info['event_B'];
                this.items = bayes_list[this.event_info.sample_name].items;
                this.s_name = this.event_info.sample_name;
        },
        focus_last_name(){
            this.$nextTick(()=>{
                let a = document.querySelectorAll('input.name_input');
                setTimeout(()=>{if(a.length>0)a[a.length-1].focus();},100);
            })

        }
    },
    computed:{
        show_cancel_normalize(){
            return this.last_PA.length>0
        },
        create_calc_eq(){
            let res = 'P(B)';
            if(!this.has_calc_PB)return res;
            let eq_array = [];
            this.items.map((v,idx)=>{
                eq_array.push(this.name_templete.PB_item.replace(/\{n\}/g,idx+1));
            });
            return res + ' = ' + eq_array.join(' + ');
        },
        PB_info(){
            let eq_array = [];
            this.items.map((v,idx)=>{
                eq_array.push(v.name_object.value);
            });
            return `${eq_array.join(',')} 的 ${this.event_info.event_B}率 的总和`
        }

    },
    watch:{
        // event_info:{
        //     deep:true,
        //     handler(c_v,o_v){
        //         console.log('event_info changed from watch');
        //         console.log(this.event_info);
        //     }
        // },
        'event_info.sample_name'(){
                console.log('event_info changed from watch');
                console.log(this.event_info);
                this.event_info.event_A = sample_list[this.event_info.sample_name].event_info['event_A'];
                this.event_info.event_B = sample_list[this.event_info.sample_name].event_info['event_B'];
                this.s_name = this.event_info.sample_name;
                console.log(this.event_info);
                this.items = sample_list[this.event_info.sample_name].items;
                this.has_update();
           
        },
        'items.l_object':{
            //deep:true,
            handler(){
                console.log('items changed:');
                console.log(this.items)
            },
        }
    },
    components:{
        BayItem,BayItemFooter,BayItemInfo
    }
}
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/var.styl';
// import img from '~pic/error.png'

.main-bayes-page
    border:1px solid rgba(0,0,0,0.2);
    //width:80%;
    flex:1;
    min-width:550px;
    display:flex;
    flex-direction :column;
    background-color:white;
    //padding-top:$main_bayes_page_padding_top;
    padding-bottom:$main_bayes_page_padding_top;
    background-repeat:no-repeat no-repeat;
    background-size:100% 100%;
    position:relative;
    //background-image:url('~pic/bayes-bg.png');

.total_bay_item
    height:$source_height + $flow_height - $main_bayes_page_padding_top;
    position:relative;
    width:100%;
    padding:20px 2px 20px 100px;
    box-sizing:border-box;
    //background: linear-gradient(2deg, #535361, #e0e0e0);
.bay-item-card-list
    height:$source_height + $flow_height - $main_bayes_page_padding_top - 30px;
    display:flex;
    justify-content:center;
    position:relative;
    width:100%;
    
.content-wrapper
    height:$source_height + $flow_height - $main_bayes_page_padding_top - 30px;
    position:relative;
    display:flex;
    flex-direction:row;
    //justify-content:center; //继承自父元素，自己使用会与overflow冲突
    padding:20px 20px;
    box-sizing:border-box;
    //background: linear-gradient(2deg, #535361, #e0e0e0);
    overflow-x:auto;
    &::-webkit-scrollbar 
        width:16px;
        height:10px;
        background-color:gray;
 
    &::-webkit-scrollbar-track
        -webkit-box-shadow:inset 0 0 6px rgba(0.8,0.8,0.8,0.3);
        border-radius:10px;
        background-color:#F5F5F5;
 
    &::-webkit-scrollbar-thumb
        border-radius:10px;
        -webkit-box-shadow:inset 0 0 6px rgba(0.8,0,0.5,.3);
        background-color:#5d9ae7;


    

.btn_calc_a,.btn_calc_b
    position:absolute;
    //transform:translateY(-50%);
    clear_default_style()
    center();
    height:60px;
    padding:5px 10px;
    font-size:20px;
    border-radius:5px;
    background-color:lighten(blue,20%);
    color:white;

    &:hover
        background-color:lighten(blue,40%);
        border:1px solid green;

.btn_calc_a
    left:50%;
    transform:translate(-50%,0%);
    width:60%;
    height:20%;
    bottom:0%;

.btn_calc_b
    right:1%;

.sample_select
    position:absolute;
    left:0%;
    top:1%;

.quick_panel
    //visibility:hidden;
    position:absolute;
    left:2px;
    bottom:10px;
    display:flex;
    flex-direction:column;
    background-color:rgb(7,38,94);
    padding:4px 2px;
    border-radius:5px;
    & button 
        margin:4px
        border-radius:5px;
        background-color:white;

        &:hover
            background-color:green;
            color:white;
.quick_panel2
    //visibility:hidden;
    position:absolute;
    left:2px;
    top:10px;
    height:40%;
    width:90px;
    //transform:translateY(-64%);
    display:flex;
    flex-direction:column;
    justify-content:space-around;
    background-color:rgb(7,38,94);
    padding:10px 8px;
    border-radius:10px;
    & button 
        margin:4px;
        font-size:15px;
        font-weight:bold;
        padding:4px;
        border-radius:8px;

        &:hover
            background-color:green;
            color:white;

</style>
